import { create } from "zustand";
import { MiniCompany } from "../services/swagger";

interface BusinessStore {
  miniCompanyList: MiniCompany[];
  setMiniCompanyList: (miniCompanyList: MiniCompany[]) => void;
}

export const useBusinessStore = create<BusinessStore>((set) => ({
  miniCompanyList: [],
  setMiniCompanyList: (miniCompanyList: MiniCompany[]) =>
    set(() => ({ miniCompanyList })),
}));
